'use client';

import { useState, useEffect } from 'react';
import { fetchCarDetails } from '../lib/data';
import { useLanguage } from '../contexts/LanguageContext';

export function useCarDetails(slug) {
  const [carData, setCarData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    const loadData = async () => {
      if (!language || !slug) return;
      
      setLoading(true);
      try {
        const data = await fetchCarDetails(slug, { lang: language });
        setCarData(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching car details:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [language, slug]);

  return { carData, loading, error };
}
